import React from 'react';
import { connect, useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { Button as UIKitButton } from '@beef/ui-kit';

import commonStyles from 'styles/common.pcss';
import { deviceButtonTitle, deviceVariant } from 'constants/device';
import { getIsBundleInBasket } from 'store/common/basket/selectors';
import { BundleFrame } from 'bricks';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { addBundleToBasket } from 'store/ProductDetails/common/actions';
import {
  getProductIsPreorder,
} from 'store/ProductDetails/selectors';
import {
  Bundle,
  composeIsBundleReady,
} from 'store/ProductDetails/bundles/selectors';
import { BUNDLE_FRAME_MOBILE, BUNDLE_FRAME_RESULT } from 'bricks/Bundles/BundleFrame';


import { BundleBuyContent } from '../BundleBuyContent';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

type BundleBuyButtonProps = {
  isPreorder: boolean;
  isBundleReady: boolean;
  onButtonClick: () => void;
  isMobile: boolean;
  bundle: Bundle;
};

const BundleBuyButton = ({
  isPreorder,
  isBundleReady,
  onButtonClick,
  isMobile,
  bundle,
}: BundleBuyButtonProps) => {
  const isBundleInBasketExists = useSelector((state) =>
    getIsBundleInBasket(state, bundle?.getPromotionId()?.toString()));


  const getButtonTitle = (isBundleInBasket) => {
    if (isBundleInBasket) {
      return deviceButtonTitle.IN_BASKET;
    }

    if (isPreorder) {
      return deviceButtonTitle.PRE_ORDER_EXTENDED;
    }

    return deviceButtonTitle.TO_BASKET;
  };

  const getButtonVariant = (isBundleInBasket) => {
    if (isBundleInBasket) {
      return deviceVariant.SECONDARY;
    }

    return deviceVariant.MAIN;
  };

  return (
    <BundleFrame
      type={isMobile ? BUNDLE_FRAME_MOBILE : BUNDLE_FRAME_RESULT}
      className={cx('result', !isMobile && 'result-with-padding')}
      key="result"
    >
      <BundleBuyContent bundle={bundle} />
      <div className={cx('pay-wrapper')}>
        <UIKitButton
          size="l"
          onClick={() => onButtonClick(bundle.getActionData())}
          disabled={!isBundleReady(bundle.getActionData())}
          fullWidth
          variant={getButtonVariant(isBundleInBasketExists)}
        >
          {getButtonTitle(isBundleInBasketExists)}
        </UIKitButton>
      </div>
    </BundleFrame>
  );
};


const mapStateToProps = state => ({
  isMobile: isScreenBelow800(state),
  isBundleReady: composeIsBundleReady(state),
  isPreorder: getProductIsPreorder(state),
});

const mapDispatchToProps = {
  onButtonClick: addBundleToBasket,
};

export default connect(mapStateToProps, mapDispatchToProps)(BundleBuyButton);

